import { createContext, useContext, useMemo, useState } from "react";

const SearchContext = createContext(null);

export function SearchProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [initialQuery, setInitialQuery] = useState("");

  const value = useMemo(() => ({
    open,
    initialQuery,
    openSearch: (q = "") => { setInitialQuery(q); setOpen(true); },
    closeSearch: () => setOpen(false),
  }), [open, initialQuery]);

  return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
}

export function useSearch() {
  return useContext(SearchContext);
}
